module.exports = __webpack_public_path__ + "src/assets/games/42/152.jpg";